const domainConfigKeys = [
  'olaApiHost',
  'olaApiAccountsPath',
  'olaProvisioningHost',
  'securepayApiHost'
];

export default domainConfigKeys;
